import { InjectionToken } from '@pulse/common';
import { PipeHost } from '../pipe';

export const InternalDataLayerToken = new InjectionToken<any[] | undefined, 'INTERNAL_DATA_LAYER'>(
    'INTERNAL_DATA_LAYER',
);
export const DataLayerToken = new InjectionToken<any[] | undefined, 'DATA_LAYER'>('DATA_LAYER');
export const DefaultPipesHostToken = new InjectionToken<PipeHost, 'DEFAULT_PIPES_HOST_TOKEN'>(
    'DEFAULT_PIPES_HOST_TOKEN',
);
export const PipesHostToken = new InjectionToken<PipeHost, 'PIPES_HOST_TOKEN'>('PIPES_HOST_TOKEN');
